/*
 * @Author       : shenqing
 * @desc         : 组件描述
 * @Date         : 2024-07-09 14:11:57
 * @LastEditTime : 2025-01-14 10:01:04
 * @LastEditors  : 秦灵
 * @FilePath     : /evalute-all/teaching_QualityService/src/store/getters.js
 */
import store from './index'
const getters = {
    getSystemInfo: state => state.app.systemInfo,
    recordCount: state => state.recordCount,
    college: state => state.projectRange.college,
    teacher: state => state.projectRange.teacher,
    commonality: state => {
        store.commit('set_commonality', JSON.parse(sessionStorage.getItem('commonality')))
        return state.aside.commonality
    },
    term: state => {
        store.commit('set_term', JSON.parse(sessionStorage.getItem('term')))
        return state.aside.term
    },
    zzbg_common: state => state.zzbg.zzbg_common,
    zzbg_formdata: state => state.zzbg.zzbg_formdata,
    get_zzbg_step: state => state.zzbg.get_zzbg_step,
    get_zzbg_node: state => state.zzbg.get_zzbg_node,
    defaultForm: state => state.progress.defaultForm,
    currentCard: state => state.card.currentCard
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js